import { FilterBadge } from './FilterBadge';

export default FilterBadge;
export * from './FilterBadge';
